var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAbstractLineImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 187 207",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 186.475,
    height: 205.6,
    transform: "translate(0.109375 0.556641)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5013 192.42C44.6956 187.392 26.0537 184.855 7.96984 182.531C4.07486 182.044 0.458629 184.763 0.180416 188.593C-0.376011 192.426 2.40775 195.931 6.02452 196.418C23.552 198.655 41.6342 201.049 58.6052 205.89C62.222 206.94 66.1186 204.778 67.2314 201.06C68.3443 197.345 66.118 193.473 62.5013 192.42Z",
    fill: "#FF9500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.473 121.135C103.346 107.654 89.4599 94.9679 75.5639 82.2726C59.125 67.2541 42.6719 52.2226 27.4444 35.8468C24.9404 33.0246 20.489 32.8734 17.7069 35.508C14.9248 38.1454 14.6476 42.5803 17.4298 45.4026C32.6566 61.8247 49.1089 76.9018 65.5471 91.9659C79.4438 104.701 93.3304 117.427 106.458 130.948C109.24 133.703 113.69 133.742 116.473 131.032C118.977 128.325 119.255 123.89 116.473 121.135Z",
    fill: "#FF9500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.473 121.135C103.346 107.654 89.4599 94.9679 75.5639 82.2726C59.125 67.2541 42.6719 52.2226 27.4444 35.8468C24.9404 33.0246 20.489 32.8734 17.7069 35.508C14.9248 38.1454 14.6476 42.5803 17.4298 45.4026C32.6566 61.8247 49.1089 76.9018 65.5471 91.9659C79.4438 104.701 93.3304 117.427 106.458 130.948C109.24 133.703 113.69 133.742 116.473 131.032C118.977 128.325 119.255 123.89 116.473 121.135Z",
    stroke: "#F4E9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.17 7.9363C171.005 24.78 171.838 41.6237 172.672 58.4702C172.672 62.3284 176.012 65.3074 179.907 65.1198C183.802 64.9294 186.583 61.6452 186.583 57.7843C185.748 40.9126 184.915 24.0436 184.081 7.17474C183.802 3.31658 180.463 0.357173 176.568 0.567159C172.952 0.777146 169.892 4.08094 170.17 7.9363Z",
    fill: "#FF9500"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAbstractLineImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AbstractLineImg.17db90ef.svg";
export { ForwardRef as ReactComponent };